import { render, staticRenderFns } from "./supplylist.vue?vue&type=template&id=2c39d742&scoped=true"
import script from "./supplylist.vue?vue&type=script&lang=js"
export * from "./supplylist.vue?vue&type=script&lang=js"
import style0 from "./supplylist.vue?vue&type=style&index=0&id=2c39d742&prod&lang=scss&scoped=true"
import style1 from "./supplylist.vue?vue&type=style&index=1&id=2c39d742&prod&lang=css"
import style2 from "./supplylist.vue?vue&type=style&index=2&id=2c39d742&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39d742",
  null
  
)

export default component.exports